import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/layout";
import DataService from "../../services/api/data_services";
import { BASE_SITE_URL } from "../../shared/constants";
import ogimage from "../../assets/Images/ogImages/article@2x.png";

// Modern components
import ArticlesHeroBanner from "../../components/ModernArticles/ArticlesHeroBanner";
import ArticlesFilterBar from "../../components/ModernArticles/ArticlesFilterBar";
import ArticlesGridSection from "../../components/ModernArticles/ArticlesGridSection";
import ArticlesCTASection from "../../components/ModernArticles/ArticlesCTASection";
import "../../components/ModernArticles/modernArticlesPage.scss";

const ArticleList = () => {
  const [limit, setLimit] = useState(10);
  const [articleData, setArticleData] = useState([]);
  const [articleRawData, setArticleRawData] = useState({});
  const [articleTag, setArticleTag] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const urlParams =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search);
  const myParam = typeof window !== "undefined" && urlParams.get("tag");

  useEffect(() => {
    setIsLoading(true);
    DataService.getData(
      `/admin/api/article-tag?limit=${limit}&type=Article&article_type=${
        myParam || "all"
      }`,
    )
      .then((response) => {
        setArticleTag(response.all_tags || []);
        setSelectedTag(response.selected_tag || "");
        setArticleData(response.data || []);
        setArticleRawData(response);
        setIsLoading(false);
        setInitialLoad(false);
      })
      .catch(() => {
        setIsLoading(false);
        setInitialLoad(false);
      });
  }, [myParam, limit]);

  const handleLoadMore = () => {
    setLimit((prev) => prev + 6);
  };

  return (
    <Layout
      seo={{
        title: "Insights | Articles | DigiRyte",
        ogtitle: "Insights | Articles | DigiRyte",
        description: "Our hub of knowledge to help your business succeed",
        ogimage: ogimage,
        ogurl: `${BASE_SITE_URL}/insights/articles`,
      }}
    >
      <div className="modern-articles-page">
        <ArticlesHeroBanner
          subtitle="Explore our latest thinking on technology, engineering, and digital transformation. Expert perspectives to help your business thrive."
          breadcrumbs={[
            { label: "Home", to: "/" },
            { label: "Insights", to: "/insights" },
            { label: "Articles" },
          ]}
          totalArticles={articleData.length || 50}
          totalTopics={articleTag.length || 10}
        />

        {myParam !== null && (
          <ArticlesFilterBar tags={articleTag} selectedTag={selectedTag} />
        )}

        {initialLoad ? (
          <div className="articles-loading-state body-container">
            <div className="loading-grid">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="loading-card-skeleton">
                  <div className="skeleton-image" />
                  <div className="skeleton-content">
                    <div className="skeleton-tag" />
                    <div className="skeleton-title" />
                    <div className="skeleton-title skeleton-title--short" />
                    <div className="skeleton-desc" />
                    <div className="skeleton-desc skeleton-desc--short" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <ArticlesGridSection
            articles={articleData}
            hasMore={articleRawData.has_more}
            onLoadMore={handleLoadMore}
            isLoading={isLoading}
          />
        )}

        <ArticlesCTASection />
      </div>
    </Layout>
  );
};

export default ArticleList;
